import React, {ReactNode, useState} from "react";
import {Modal} from "antd";
import styles from "./contact-us-button.module.scss";
import contactUsQrCode from "@/assets/images/contact-us-qr-code-huanyu.webp";
import {useTranslation} from "react-i18next";

export default function ContactUsButton(props: {
  className: string,
  children: ReactNode
}) {
	const {t} = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleContact = () => {
    setIsModalOpen(true);
  }

  return (
    <>
      <div className={props.className} onClick={handleContact}>
        {props.children}
      </div>
      <Modal
        width={498}
        footer={null}
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
        }}
      >
        <div className={styles.modalContent}>
          <div className={styles.modalText}>
						{t("tips.contactUs")}
          </div>
          <img
						src={contactUsQrCode}
            alt={"QR Code"}
            width={208}
            height={208}
          />
        </div>
      </Modal></>
  )
}
